import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFilteredShopProductsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.Shop_Products_Bool_Exp>;
}>;


export type GetFilteredShopProductsQuery = { __typename?: 'query_root', shop_products: Array<{ __typename?: 'shop_products', id: any, product_id: any, property_id: any, created_at: any, product?: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, organization_id?: any | null, workspace_id?: any | null, created_at?: any | null, retail_price?: any | null, extended_price?: any | null, photo_link?: string | null, partition_id?: string | null, parent_product_id?: any | null, product_category: { __typename?: 'product_categories', name: string, label: string }, parent_product?: { __typename?: 'products', id: any, name: string, make: string, model: string, description: string } | null, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, description?: string | null, name?: string | null }> } | null, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, organization?: { __typename?: 'organizations', id: any, name: string, display_price?: boolean | null, type?: string | null } | null } | null }> };


export const GetFilteredShopProductsDocument = gql`
    query getFilteredShopProducts($where: shop_products_bool_exp) {
  shop_products(where: $where, order_by: {created_at: asc}) {
    id
    product_id
    property_id
    created_at
    product {
      id
      name
      description
      sku
      product_category {
        name
        label
      }
      make
      model
      organization_id
      workspace_id
      created_at
      retail_price
      extended_price
      photo_link
      partition_id
      parent_product_id
      parent_product {
        id
        name
        make
        model
        description
      }
      product_attachments(order_by: {created_at: asc}) {
        id
        photo_link
        document_link
        video_link
        audio_link
        site_link
        transcription
        transcribed
        type
        description
        name
      }
    }
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      organization {
        id
        name
        display_price
        type
      }
    }
  }
}
    `;

/**
 * __useGetFilteredShopProductsQuery__
 *
 * To run a query within a React component, call `useGetFilteredShopProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredShopProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredShopProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFilteredShopProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredShopProductsQuery, GetFilteredShopProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredShopProductsQuery, GetFilteredShopProductsQueryVariables>(GetFilteredShopProductsDocument, options);
      }
export function useGetFilteredShopProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredShopProductsQuery, GetFilteredShopProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredShopProductsQuery, GetFilteredShopProductsQueryVariables>(GetFilteredShopProductsDocument, options);
        }
export function useGetFilteredShopProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredShopProductsQuery, GetFilteredShopProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilteredShopProductsQuery, GetFilteredShopProductsQueryVariables>(GetFilteredShopProductsDocument, options);
        }
export type GetFilteredShopProductsQueryHookResult = ReturnType<typeof useGetFilteredShopProductsQuery>;
export type GetFilteredShopProductsLazyQueryHookResult = ReturnType<typeof useGetFilteredShopProductsLazyQuery>;
export type GetFilteredShopProductsSuspenseQueryHookResult = ReturnType<typeof useGetFilteredShopProductsSuspenseQuery>;
export type GetFilteredShopProductsQueryResult = Apollo.QueryResult<GetFilteredShopProductsQuery, GetFilteredShopProductsQueryVariables>;